import { ALERT_RULE_KEYS, SEVERITIES, type AlertListQuery, type AlertRuleKey, type Severity } from '@convometry/contracts';

// Pure helpers for the alert inbox (URL params, labels, snooze options).

export const ALERT_VIEWS: ReadonlyArray<{ value: AlertListQuery['view']; label: string }> = [
  { value: 'active', label: 'Activas' },
  { value: 'open', label: 'Nuevas y vistas' },
  { value: 'snoozed', label: 'Pospuestas' },
  { value: 'closed', label: 'Cerradas' },
  { value: 'all', label: 'Todas' },
];

export const SNOOZE_OPTIONS: ReadonlyArray<{ minutes: number; label: string }> = [
  { minutes: 30, label: '30 minutos' },
  { minutes: 120, label: '2 horas' },
  { minutes: 24 * 60, label: '1 día' },
];

export interface AlertFilters {
  view: AlertListQuery['view'];
  priority?: Severity;
  ruleKey?: AlertRuleKey;
  agentId?: string;
}

export function parseAlertFilters(sp: URLSearchParams): AlertFilters {
  const v = sp.get('vista');
  const view = ALERT_VIEWS.some((x) => x.value === v) ? (v as AlertFilters['view']) : 'active';
  const p = sp.get('prioridad');
  const r = sp.get('regla');
  const a = sp.get('asesor');
  return {
    view,
    ...((SEVERITIES as readonly string[]).includes(p ?? '') ? { priority: p as Severity } : {}),
    ...((ALERT_RULE_KEYS as readonly string[]).includes(r ?? '') ? { ruleKey: r as AlertRuleKey } : {}),
    ...(a ? { agentId: a } : {}),
  };
}

/** Spanish explanation of an audit-trail transition. */
export function alertReasonLabel(reason: string, actorName: string | null): string {
  const by = actorName ? ` por ${actorName}` : '';
  switch (reason) {
    case 'condition_detected':
      return 'Condición detectada';
    case 'condition_cleared':
      return 'Se resolvió sola (la condición ya no se cumple)';
    case 'snooze_ended':
      return 'Terminó la pausa';
    case 'expired':
      return 'Expiró';
    case 'acknowledge':
      return `Vista${by}`;
    case 'snooze':
      return `Pospuesta${by}`;
    case 'resolve':
      return `Resuelta${by}`;
    default:
      return reason;
  }
}

/** Active alerts shown on the nav badge: open + acknowledged (snoozed excluded). */
export function activeAlertCount(summary: { active: Record<Severity, number> } | undefined): number {
  if (!summary) return 0;
  return SEVERITIES.reduce((s, p) => s + summary.active[p], 0);
}
